import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  sideMenu: {
    display: "flex",
    flexDirection: "column",
    marginRight: 15,
  },
  categoryMain: {
    display: "flex",
    "&.MuiListItem-root": {
      justifyContent: "space-between",
    },
  },
  textMain: {
    textTransform: "uppercase",
  },
  textSub: {
    fontWeight: 600,
    paddingLeft: "31px !important",
  },
  subsubCat: {
    listStyleType: "disc",
    display: "list-item !important",
  },
  productUl: {
    listStyle: "inside",
  },
  sidebarSearch: {
    "&.MuiFormControl-root": {
      border: `1px solid ${theme.color.gray3}`,
      paddingLeft: 5,
      borderRadius: 2,
      marginBottom: 20,
    },
  },
  muiList: {
    "&.MuiList-root": {
      marginLeft: -16,
    },
  },
  categorieLabel: {
    textTransform: "uppercase",
  },
  categActif: {
    textDecoration: "underline !important",
  },
  CircularProgress: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "white",
    marginTop: 25,
  },
}));

export default useStyles;
